import { gql } from '@apollo/client';

export const VALIDATE_EMAIL = gql`
  query Flex_ValidateEmail($email: String!) {
    validateEmail(email: $email) {
      userExists
      valid
      validationErrorMessage
    }
  }
`;
